//#region IMPORTS
import { promosSelectors } from "../../features/promos/promosSlice";
import { useAppSelector } from "../../store/configureStore";
import { useTranslation } from "react-i18next";
import BasketEmptyPromoItem from "./BasketEmptyPromoItem";
import BasketEmptyStaticItem from "./BasketEmptyStaticItem";
import { Fragment } from "react";
import useActiveWeekInstoreTemplate from "../../hooks/useActiveWeekInstoreTemplate";
import useActiveWeekInstoreTemplateForStore from "../../hooks/useActiveWeekInstoreTemplateForStore";
import useAdminManager from "../../hooks/useAdminManager";
import useHQmanager from "../../hooks/useHQmanager";
//#endregion

export default function BasketEmpty() {
  //#region SETUP
  // Translation
  const { t } = useTranslation();

  // Redux
  const { user } = useAppSelector((state) => state.account);
  const isAdmin = useAdminManager(user);
  const isHq = useHQmanager(user);

  // Admin/HQ only order instore week orders from this screen; backorderable
  // promos are reserved for shop users.
  const allPromos = useAppSelector(promosSelectors.selectAll);
  const promos =
    isAdmin || isHq
      ? []
      : allPromos.filter((promo) => promo.back_orderable);

  // Week template to surface here:
  //  - shop users: the one available for their own store format
  //  - admin / HQ: any active one (they pick the store later in the week-order
  //    screen, which then resolves the matching template)
  const shopUser = !isAdmin && !isHq;
  const anyWeekTemplate = useActiveWeekInstoreTemplate();
  const shopWeekTemplate = useActiveWeekInstoreTemplateForStore(
    user?.store?.store_format_id,
  );
  const activeWeekTemplate = shopUser ? shopWeekTemplate : anyWeekTemplate;
  //#endregion

  //#region RENDER
  return (
    <main className="w-full flex items-center justify-center py-32">
      <div className="mx-auto max-w-full">
        <h2 className="text-2xl font-semibold text-gray-900">
          {t("rituals.yourBasketIsEmpty")}
        </h2>

        {(!!activeWeekTemplate || (!!promos && promos.length > 0)) && (
          <Fragment>
            <p className="mt-1 text-sm text-gray-500">
              {t("rituals.getStartedBySelectingItemsFromABackorderablePromoOrInstoreOrders")}.
            </p>
            <ul className="mt-6 divide-y divide-gray-200 border-t border-b border-gray-200">
              {activeWeekTemplate && (
                <BasketEmptyStaticItem template={activeWeekTemplate} />
              )}
              {promos.map((promo) => (
                <BasketEmptyPromoItem promo={promo} key={promo.id} />
              ))}
            </ul>
          </Fragment>
        )}
      </div>
    </main>
  );
  //#endregion
}
